export const PLUGINS_KEYS = {
  timelineEventSort: "swivuSchedulerTimelineSort",
  schedulerMenu: "swivuSchedulerMenu",
  schedulerEventMenu: "swivuSchedulerEventMenu",
  gridSearch: "swivuGridSearch",
  rowReorderExtend: "rowReorderExtend",
  swivuTimelineConfigurator: "swivuTimelineConfigurator",
};
